import { Box, Typography } from "@mui/material";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  ReferenceManyField,
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SingleFieldList,
  TextField,
  EditButton,
  required,
  ImageField,
  Create,
  TabbedForm,
  FormTab,
  ArrayInput,
  SimpleFormIterator,
  Button,
  FormDataConsumer,
} from "react-admin";

import DataGridExtended from "../../../components/list/data.grid.extended";

export const AIAssistantInstanceList = () => (
  <List resource="aiassistantinstance" actions={null}>
    <DataGridExtended rowClick="edit" title={"Agents"}>
      <TextField source="name" />
      <TextField source="description" />
    </DataGridExtended>
  </List>
);

export const AIAssistantInstanceEdit = () => {
  return (
    <Edit>
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="description" />
      </SimpleForm>
    </Edit>
  );
};
